const getDurationString = (durationInSeconds: number): string => {
    if (durationInSeconds <= 0) return '';

    // if under 1 hour, show durationInSeconds as MINUTES
    if (durationInSeconds > 0 && durationInSeconds < 3600)
        return Math.floor(durationInSeconds / 60) + ' minutes';

    // if between 1 hour and 2, show as 1 HOUR and MINUTES
    if (durationInSeconds >= 3600 && durationInSeconds < 7200) {
        let hour = Math.floor(durationInSeconds / 3600);
        let remainingSeconds = durationInSeconds % 3600;
        let remainingMinutes = Math.round(remainingSeconds / 60);
        return hour + ` hour ` + (remainingMinutes ? remainingMinutes + ' minutes' : '');
    }

    // if under 7 hours, show as HOURS and MINUTES
    if (durationInSeconds >= 7200 && durationInSeconds < 25200) {
        let hours = Math.floor(durationInSeconds / 3600);
        let remainingSeconds = durationInSeconds % 3600;
        let remainingMinutes = Math.round(remainingSeconds / 60);
        return hours + ` hours ` + (remainingMinutes ? remainingMinutes + ' minutes' : '');
    }

    // if between 7 hours and 24 hours show as a DAY
    if (durationInSeconds >= 25200 && durationInSeconds < 97200) return 'Full day';

    // if between 27 hours and 48 hours show as AS TWO DAYS
    if (durationInSeconds >= 97200 && durationInSeconds < 172801) return 'Two days';

    // if over 48 hours but under 2 weeks, show durationInSeconds in DAYS
    if (durationInSeconds >= 172801 && durationInSeconds < 1209600)
        return Math.ceil(durationInSeconds / 86400) + ' days';

    // if over 2 weeks but under 6 weeks , show durationInSeconds in weeks
    if (durationInSeconds >= 1209600 && durationInSeconds < 3628800)
        return Math.ceil(durationInSeconds / 604800) + ' weeks';

    // if over 6 weeks , show durationInSeconds in months
    // if remainder if over 8 days, we'll round up, otherwise, round down
    if (durationInSeconds % 2629757 >= 691200) {
        return Math.ceil(durationInSeconds / 2629757) + ' months';
    } else {
        return Math.round(durationInSeconds / 2629757) + ' months';
    }
};

export default getDurationString;
